import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewSupportTiceketPage from "../../components/SupportTicket/ViewSupportTicket";



const ViewSupportTicket= () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb id="title" title="View Support Ticket" title2="Support Ticket" link2="/supportticket" />

        {/* AddUserLayer */}
        <ViewSupportTiceketPage />


      </MasterLayout>
    </>
  );
};

export default ViewSupportTicket;
